import Dialog from "../../atoms/dialog";
import { Button, Grid } from "@material-ui/core";
import { useState, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import errorConvertor from '../../../services/errorConvertor';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';


export default function ErrorPresenter(props) {

    const { errors, closeCallback, cancelCallback, messageTemplate } = props;
    
    const [errorSentence, setErrorSentence] = useState([]);
    const [open, setOpen] = useState(true);

    useEffect(() => {
        const converter = new errorConvertor(errors);

        if (messageTemplate !== undefined) {
            converter.customConvert(messageTemplate);
        }
        else {
            converter.convert();
        }
        // converter.convert();
        setErrorSentence(converter.sentences)
    }, []);

    const handleClose = () => {
        setOpen(false);
    }

    const onClose = () => {
        if (closeCallback !== undefined) closeCallback()
        handleClose()
    }


    return (
        <Dialog
            title={'Alert'}
            open={open}
            handleClose={handleClose}
            disableContentPadding={true}
        >
            <Grid container direction={"row"}>

                <Grid item xs={12}>

                    <List dense={false}>
                        {errorSentence.map((sentence, index) => {
                            return (<ListItem style={{ borderBottom: '0.1rem solid #ccc' }}>
                                <ListItemIcon>
                                    {sentence.type == 'info' ? <InfoIcon style={{ color: 'blue' }} /> : sentence.type == 'warning' ? <WarningIcon style={{ color: 'orange' }} /> : <ErrorIcon style={{ color: 'red' }} />}
                                    {/* <ForwardIcon fontSize='small' style={{ color: sentence.type == 'info' ? 'blue' : sentence.type == 'warning' ? 'orange' : 'red' }} /> */}
                                </ListItemIcon>
                                <ListItemText

                                    primary={sentence.error}
                                />
                            </ListItem>)

                        })}
                    </List>
                </Grid>
            </Grid>
            <Grid container direction={"row"} style={{ padding: "12px" }} >
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end"}} >
                    {cancelCallback !== undefined && <Button color="primary" variant="outlined" style={{ marginLeft: 10 }} onClick={cancelCallback}> Cancel </Button>}
                    <Button color="primary" variant="contained" style={{ marginLeft: 10 }} onClick={onClose}> OK </Button>

                </Grid>
            </Grid>


        </Dialog>
    )

}